/* eslint-disable */
export const _city = {
    "10": [],
    "11": [],
    "12": [],
    "13": [],
    "14": [
        {
            "id": "44",
            "type": "3",
            "content": "石家庄",
            "spell": "shijiazhuang",
            "shortspell": "sjz",
            "url": "shijiazhuang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "38.048958314615",
            "lng": "114.52208184421",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:26:38",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:26:38",
            "deleted": "0"
        },
        {
            "id": "45",
            "type": "3",
            "content": "唐山",
            "spell": "tangshan",
            "shortspell": "ts",
            "url": "tangshan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "39.650530922537",
            "lng": "118.18345059773",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:26:40",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:26:40",
            "deleted": "0"
        },
        {
            "id": "46",
            "type": "3",
            "content": "秦皇岛",
            "spell": "qinhuangdao",
            "shortspell": "qhd",
            "url": "qinhuangdao",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "39.945461565898",
            "lng": "119.60436761612",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:26:42",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:26:42",
            "deleted": "0"
        },
        {
            "id": "47",
            "type": "3",
            "content": "邯郸",
            "spell": "handan",
            "shortspell": "hd",
            "url": "handan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "36.609307928471",
            "lng": "114.48269393234",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:26:44",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:26:44",
            "deleted": "0"
        },
        {
            "id": "48",
            "type": "3",
            "content": "邢台",
            "spell": "xingtai",
            "shortspell": "xt",
            "url": "xingtai",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "37.069531196912",
            "lng": "114.52048681294",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:26:45",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:26:45",
            "deleted": "0"
        },
        {
            "id": "49",
            "type": "3",
            "content": "保定",
            "spell": "baoding",
            "shortspell": "bd",
            "url": "baoding",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "38.886564548027",
            "lng": "115.49481016908",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:26:47",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:26:47",
            "deleted": "0"
        },
        {
            "id": "50",
            "type": "3",
            "content": "张家口",
            "spell": "zhangjiakou",
            "shortspell": "zjk",
            "url": "zhangjiakou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "40.811188491103",
            "lng": "114.89378153033",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:26:48",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:26:48",
            "deleted": "0"
        },
        {
            "id": "51",
            "type": "3",
            "content": "承德",
            "spell": "chengde",
            "shortspell": "cd",
            "url": "chengde",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "40.992521052457",
            "lng": "117.93382245584",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:26:50",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:26:50",
            "deleted": "0"
        },
        {
            "id": "52",
            "type": "3",
            "content": "沧州",
            "spell": "cangzhou",
            "shortspell": "cz",
            "url": "cangzhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "38.297615350326",
            "lng": "116.86380647644",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:26:51",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:26:51",
            "deleted": "0"
        },
        {
            "id": "53",
            "type": "3",
            "content": "廊坊",
            "spell": "langfang",
            "shortspell": "lf",
            "url": "langfang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "39.518610625085",
            "lng": "116.70360222264",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:26:52",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:26:52",
            "deleted": "0"
        },
        {
            "id": "54",
            "type": "3",
            "content": "衡水",
            "spell": "hengshui",
            "shortspell": "hs",
            "url": "hengshui",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "37.746929045857",
            "lng": "115.68622865291",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:26:54",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:26:54",
            "deleted": "0"
        }
    ],
    "15": [
        {
            "id": "55",
            "type": "3",
            "content": "太原",
            "spell": "taiyuan",
            "shortspell": "ty",
            "url": "taiyuan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "37.890277053968",
            "lng": "112.55086358906",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:26:55",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:26:55",
            "deleted": "0"
        },
        {
            "id": "56",
            "type": "3",
            "content": "大同",
            "spell": "datong",
            "shortspell": "dt",
            "url": "datong",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "46.070051001663",
            "lng": "124.69907739268",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:26:57",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:26:57",
            "deleted": "0"
        },
        {
            "id": "57",
            "type": "3",
            "content": "阳泉",
            "spell": "yangquan",
            "shortspell": "yq",
            "url": "yangquan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "37.869529493223",
            "lng": "113.56923760163",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:26:58",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:26:58",
            "deleted": "0"
        },
        {
            "id": "58",
            "type": "3",
            "content": "长治",
            "spell": "changzhi",
            "shortspell": "cz",
            "url": "changzhi",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "36.201664385743",
            "lng": "113.12029208573",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:26:59",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:26:59",
            "deleted": "0"
        },
        {
            "id": "59",
            "type": "3",
            "content": "晋城",
            "spell": "jincheng",
            "shortspell": "jc",
            "url": "jincheng",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "35.499834467226",
            "lng": "112.86733275751",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:27:01",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:27:01",
            "deleted": "0"
        },
        {
            "id": "60",
            "type": "3",
            "content": "朔州",
            "spell": "shuozhou",
            "shortspell": "sz",
            "url": "shuozhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "39.337671966221",
            "lng": "112.47992772666",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:27:02",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:27:02",
            "deleted": "0"
        },
        {
            "id": "61",
            "type": "3",
            "content": "晋中",
            "spell": "jinzhong",
            "shortspell": "jz",
            "url": "jinzhong",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "37.693361526798",
            "lng": "112.73851439992",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:27:04",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:27:04",
            "deleted": "0"
        },
        {
            "id": "62",
            "type": "3",
            "content": "运城",
            "spell": "yuncheng",
            "shortspell": "yc",
            "url": "yuncheng",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "35.038859479812",
            "lng": "111.00685365308",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:27:05",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:27:05",
            "deleted": "0"
        },
        {
            "id": "63",
            "type": "3",
            "content": "忻州",
            "spell": "xinzhou",
            "shortspell": "xz",
            "url": "xinzhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "38.461030572959",
            "lng": "112.72793882881",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:27:06",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:27:06",
            "deleted": "0"
        },
        {
            "id": "64",
            "type": "3",
            "content": "临汾",
            "spell": "linfen",
            "shortspell": "lf",
            "url": "linfen",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "36.099745443585",
            "lng": "111.53878759641",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:27:08",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:27:08",
            "deleted": "0"
        },
        {
            "id": "65",
            "type": "3",
            "content": "吕梁",
            "spell": "luliang",
            "shortspell": "ll",
            "url": "luliang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "37.527316096963",
            "lng": "111.14315660235",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:27:09",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:27:09",
            "deleted": "0"
        }
    ],
    "16": [
        {
            "id": "66",
            "type": "3",
            "content": "呼和浩特",
            "spell": "huhehaote",
            "shortspell": "hhht",
            "url": "huhehaote",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "40.828318873082",
            "lng": "111.66035052005",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:27:11",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:27:11",
            "deleted": "0"
        },
        {
            "id": "67",
            "type": "3",
            "content": "包头",
            "spell": "baotou",
            "shortspell": "bt",
            "url": "baotou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "40.647119425709",
            "lng": "109.84623853249",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:27:12",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:27:12",
            "deleted": "0"
        },
        {
            "id": "68",
            "type": "3",
            "content": "乌海",
            "spell": "wuhai",
            "shortspell": "wh",
            "url": "wuhai",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "39.683177006785",
            "lng": "106.83199909716",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:27:14",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:27:14",
            "deleted": "0"
        },
        {
            "id": "69",
            "type": "3",
            "content": "赤峰",
            "spell": "chifeng",
            "shortspell": "cf",
            "url": "chifeng",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "42.297112320317",
            "lng": "118.93076119217",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:27:16",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:27:16",
            "deleted": "0"
        },
        {
            "id": "70",
            "type": "3",
            "content": "通辽",
            "spell": "tongliao",
            "shortspell": "tl",
            "url": "tongliao",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "43.633756072996",
            "lng": "122.26036326322",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:27:17",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:27:17",
            "deleted": "0"
        },
        {
            "id": "71",
            "type": "3",
            "content": "鄂尔多斯",
            "spell": "eerduosi",
            "shortspell": "eeds",
            "url": "eerduosi",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "39.816489560602",
            "lng": "109.99370625145",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:27:19",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:27:19",
            "deleted": "0"
        },
        {
            "id": "72",
            "type": "3",
            "content": "呼伦贝尔",
            "spell": "hulunbeier",
            "shortspell": "hlbe",
            "url": "hulunbeier",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "49.201636054604",
            "lng": "119.760821794",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:27:21",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:27:21",
            "deleted": "0"
        },
        {
            "id": "73",
            "type": "3",
            "content": "巴彦淖尔",
            "spell": "bayannaoer",
            "shortspell": "byne",
            "url": "bayannaoer",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "40.769179902429",
            "lng": "107.42380671968",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:27:22",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:27:22",
            "deleted": "0"
        },
        {
            "id": "74",
            "type": "3",
            "content": "乌兰察布",
            "spell": "wulanchabu",
            "shortspell": "wlcb",
            "url": "wulanchabu",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "41.022362946751",
            "lng": "113.11284639068",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:27:24",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:27:24",
            "deleted": "0"
        },
        {
            "id": "75",
            "type": "3",
            "content": "兴安盟",
            "spell": "xinganmeng",
            "shortspell": "xam",
            "url": "xinganmeng",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "46.083757065182",
            "lng": "122.04816651407",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:27:25",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:27:25",
            "deleted": "0"
        },
        {
            "id": "76",
            "type": "3",
            "content": "锡林郭勒盟",
            "spell": "xilinguolemeng",
            "shortspell": "xlglm",
            "url": "xilinguolemeng",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "43.939704842324",
            "lng": "116.02733968896",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:27:27",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:27:27",
            "deleted": "0"
        },
        {
            "id": "77",
            "type": "3",
            "content": "阿拉善盟",
            "spell": "alashanmeng",
            "shortspell": "alsm",
            "url": "alashanmeng",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "38.843075264408",
            "lng": "105.69568287113",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:27:28",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:27:28",
            "deleted": "0"
        }
    ],
    "17": [
        {
            "id": "78",
            "type": "3",
            "content": "沈阳",
            "spell": "shenyang",
            "shortspell": "sy",
            "url": "shenyang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "41.808644783516",
            "lng": "123.43279092161",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:27:30",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:27:30",
            "deleted": "0"
        },
        {
            "id": "79",
            "type": "3",
            "content": "大连",
            "spell": "dalian",
            "shortspell": "dl",
            "url": "dalian",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "38.948709938304",
            "lng": "121.59347778144",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:27:31",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:27:31",
            "deleted": "0"
        },
        {
            "id": "80",
            "type": "3",
            "content": "鞍山",
            "spell": "anshan",
            "shortspell": "as",
            "url": "anshan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "41.118743682153",
            "lng": "123.00776332888",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:27:42",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:27:42",
            "deleted": "0"
        },
        {
            "id": "81",
            "type": "3",
            "content": "抚顺",
            "spell": "fushun",
            "shortspell": "fs",
            "url": "fushun",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "41.877303829591",
            "lng": "123.92981976705",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:27:43",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:27:43",
            "deleted": "0"
        },
        {
            "id": "82",
            "type": "3",
            "content": "本溪",
            "spell": "benxi",
            "shortspell": "bx",
            "url": "benxi",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "41.325837626649",
            "lng": "123.77806236979",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:27:44",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:27:44",
            "deleted": "0"
        },
        {
            "id": "83",
            "type": "3",
            "content": "丹东",
            "spell": "dandong",
            "shortspell": "dd",
            "url": "dandong",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "40.129022826638",
            "lng": "124.33854311477",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:27:55",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:27:55",
            "deleted": "0"
        },
        {
            "id": "84",
            "type": "3",
            "content": "锦州",
            "spell": "jinzhou",
            "shortspell": "jz",
            "url": "jinzhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "41.130878875917",
            "lng": "121.14774873824",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:27:56",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:27:56",
            "deleted": "0"
        },
        {
            "id": "85",
            "type": "3",
            "content": "营口",
            "spell": "yingkou",
            "shortspell": "yk",
            "url": "yingkou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "40.668651066474",
            "lng": "122.23339137079",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:27:58",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:27:58",
            "deleted": "0"
        },
        {
            "id": "86",
            "type": "3",
            "content": "阜新",
            "spell": "fuxin",
            "shortspell": "fx",
            "url": "fuxin",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "42.01925010706",
            "lng": "121.66082212857",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:27:59",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:27:59",
            "deleted": "0"
        },
        {
            "id": "87",
            "type": "3",
            "content": "辽阳",
            "spell": "liaoyang",
            "shortspell": "ly",
            "url": "liaoyang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "41.273339265569",
            "lng": "123.17245120515",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:01",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:01",
            "deleted": "0"
        },
        {
            "id": "88",
            "type": "3",
            "content": "盘锦",
            "spell": "panjin",
            "shortspell": "pj",
            "url": "panjin",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "41.141248022956",
            "lng": "122.07322781023",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:02",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:02",
            "deleted": "0"
        },
        {
            "id": "89",
            "type": "3",
            "content": "铁岭",
            "spell": "tieling",
            "shortspell": "tl",
            "url": "tieling",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "42.299757012125",
            "lng": "123.85484961462",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:03",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:03",
            "deleted": "0"
        },
        {
            "id": "90",
            "type": "3",
            "content": "朝阳",
            "spell": "chaoyang",
            "shortspell": "cy",
            "url": "chaoyang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "39.958953166407",
            "lng": "116.52169489108",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:05",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:05",
            "deleted": "0"
        },
        {
            "id": "91",
            "type": "3",
            "content": "葫芦岛",
            "spell": "huludao",
            "shortspell": "hld",
            "url": "huludao",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "40.743029881318",
            "lng": "120.86075764476",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:06",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:06",
            "deleted": "0"
        }
    ],
    "18": [
        {
            "id": "92",
            "type": "3",
            "content": "长春",
            "spell": "changchun",
            "shortspell": "cc",
            "url": "changchun",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "43.898337607098",
            "lng": "125.3136424272",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:07",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:07",
            "deleted": "0"
        },
        {
            "id": "93",
            "type": "3",
            "content": "吉林",
            "spell": "jilin",
            "shortspell": "jl",
            "url": "jilin1",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "43.871988334359",
            "lng": "126.56454398883",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:09",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:09",
            "deleted": "0"
        },
        {
            "id": "94",
            "type": "3",
            "content": "四平",
            "spell": "siping",
            "shortspell": "sp",
            "url": "siping",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "43.175524701126",
            "lng": "124.39138207368",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:10",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:10",
            "deleted": "0"
        },
        {
            "id": "95",
            "type": "3",
            "content": "辽源",
            "spell": "liaoyuan",
            "shortspell": "ly",
            "url": "liaoyuan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "42.923302619054",
            "lng": "125.13368605218",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:12",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:12",
            "deleted": "0"
        },
        {
            "id": "96",
            "type": "3",
            "content": "通化",
            "spell": "tonghua",
            "shortspell": "th",
            "url": "tonghua",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "41.736397129868",
            "lng": "125.94265013851",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:13",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:13",
            "deleted": "0"
        },
        {
            "id": "97",
            "type": "3",
            "content": "白山",
            "spell": "baishan",
            "shortspell": "bs",
            "url": "baishan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "41.945859397018",
            "lng": "126.43579767535",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:15",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:15",
            "deleted": "0"
        },
        {
            "id": "98",
            "type": "3",
            "content": "松原",
            "spell": "songyuan",
            "shortspell": "sy",
            "url": "songyuan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "45.136048970084",
            "lng": "124.83299453234",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:16",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:16",
            "deleted": "0"
        },
        {
            "id": "99",
            "type": "3",
            "content": "白城",
            "spell": "baicheng",
            "shortspell": "bc",
            "url": "baicheng",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "45.621086275219",
            "lng": "122.8407766791",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:18",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:18",
            "deleted": "0"
        },
        {
            "id": "100",
            "type": "3",
            "content": "延边",
            "spell": "yanbian",
            "shortspell": "yb",
            "url": "yanbian",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "42.896413603744",
            "lng": "129.48590195816",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:19",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:19",
            "deleted": "0"
        }
    ],
    "19": [
        {
            "id": "101",
            "type": "3",
            "content": "哈尔滨",
            "spell": "haerbin",
            "shortspell": "heb",
            "url": "haerbin",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "45.773224633239",
            "lng": "126.65771685545",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:20",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:20",
            "deleted": "0"
        },
        {
            "id": "102",
            "type": "3",
            "content": "齐齐哈尔",
            "spell": "qiqihaer",
            "shortspell": "qqhe",
            "url": "qiqihaer",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "47.347699813366",
            "lng": "123.98728894217",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:22",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:22",
            "deleted": "0"
        },
        {
            "id": "103",
            "type": "3",
            "content": "鸡西",
            "spell": "jixi",
            "shortspell": "jx",
            "url": "jixi",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "45.321539886551",
            "lng": "130.94176727325",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:23",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:23",
            "deleted": "0"
        },
        {
            "id": "104",
            "type": "3",
            "content": "鹤岗",
            "spell": "hegang",
            "shortspell": "hg",
            "url": "hegang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "47.338665903727",
            "lng": "130.29247205063",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:25",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:25",
            "deleted": "0"
        },
        {
            "id": "105",
            "type": "3",
            "content": "双鸭山",
            "spell": "shuangyashan",
            "shortspell": "sys",
            "url": "shuangyashan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "46.655102062482",
            "lng": "131.17140173958",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:26",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:26",
            "deleted": "0"
        },
        {
            "id": "106",
            "type": "3",
            "content": "大庆",
            "spell": "daqing",
            "shortspell": "dq",
            "url": "daqing",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "46.596709020008",
            "lng": "125.02183973021",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:27",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:27",
            "deleted": "0"
        },
        {
            "id": "107",
            "type": "3",
            "content": "伊春",
            "spell": "yichun",
            "shortspell": "yc",
            "url": "yichun",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "47.741959238189",
            "lng": "128.90057964259",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:29",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:29",
            "deleted": "0"
        },
        {
            "id": "108",
            "type": "3",
            "content": "佳木斯",
            "spell": "jiamusi",
            "shortspell": "jms",
            "url": "jiamusi",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "46.81377960474",
            "lng": "130.28473458595",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:30",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:30",
            "deleted": "0"
        },
        {
            "id": "109",
            "type": "3",
            "content": "七台河",
            "spell": "qitaihe",
            "shortspell": "qth",
            "url": "qitaihe",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "45.77500536864",
            "lng": "131.01904804712",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:31",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:31",
            "deleted": "0"
        },
        {
            "id": "110",
            "type": "3",
            "content": "牡丹江",
            "spell": "mudanjiang",
            "shortspell": "mdj",
            "url": "mudanjiang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "44.588521152783",
            "lng": "129.60803539564",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:33",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:33",
            "deleted": "0"
        },
        {
            "id": "111",
            "type": "3",
            "content": "黑河",
            "spell": "heihe",
            "shortspell": "hh",
            "url": "heihe",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "50.250690090738",
            "lng": "127.50083029524",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:34",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:34",
            "deleted": "0"
        },
        {
            "id": "112",
            "type": "3",
            "content": "绥化",
            "spell": "suihua",
            "shortspell": "sh",
            "url": "suihua",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "46.646063926997",
            "lng": "126.98909457163",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:36",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:36",
            "deleted": "0"
        },
        {
            "id": "113",
            "type": "3",
            "content": "大兴安岭",
            "spell": "daxinganling",
            "shortspell": "dxal",
            "url": "daxinganling",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "51.991788968014",
            "lng": "124.19610419017",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:37",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:37",
            "deleted": "0"
        }
    ],
    "20": [
        {
            "id": "114",
            "type": "3",
            "content": "南京",
            "spell": "nanjing",
            "shortspell": "nj",
            "url": "nanjing",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "32.057235501806",
            "lng": "118.77807440803",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:39",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:39",
            "deleted": "0"
        },
        {
            "id": "115",
            "type": "3",
            "content": "无锡",
            "spell": "wuxi",
            "shortspell": "wx",
            "url": "wuxi",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "31.570037451923",
            "lng": "120.30545590054",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:40",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:40",
            "deleted": "0"
        },
        {
            "id": "116",
            "type": "3",
            "content": "徐州",
            "spell": "xuzhou",
            "shortspell": "xz",
            "url": "xuzhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "34.271553431092",
            "lng": "117.18810662318",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:42",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:42",
            "deleted": "0"
        },
        {
            "id": "117",
            "type": "3",
            "content": "常州",
            "spell": "changzhou",
            "shortspell": "cz",
            "url": "changzhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "31.771396744684",
            "lng": "119.98186101346",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:43",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:43",
            "deleted": "0"
        },
        {
            "id": "118",
            "type": "3",
            "content": "苏州",
            "spell": "suzhou",
            "shortspell": "sz",
            "url": "suzhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "31.317987367952",
            "lng": "120.61990711549",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:45",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:45",
            "deleted": "0"
        },
        {
            "id": "119",
            "type": "3",
            "content": "南通",
            "spell": "nantong",
            "shortspell": "nt",
            "url": "nantong",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "32.014664540823",
            "lng": "120.87380095093",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:47",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:47",
            "deleted": "0"
        },
        {
            "id": "120",
            "type": "3",
            "content": "连云港",
            "spell": "lianyungang",
            "shortspell": "lyg",
            "url": "lianyungang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "34.60154896701",
            "lng": "119.17387221742",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:48",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:48",
            "deleted": "0"
        },
        {
            "id": "121",
            "type": "3",
            "content": "淮安",
            "spell": "huaian",
            "shortspell": "ha",
            "url": "huaian",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "33.606512739276",
            "lng": "119.03018636466",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:49",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:49",
            "deleted": "0"
        },
        {
            "id": "122",
            "type": "3",
            "content": "盐城",
            "spell": "yancheng",
            "shortspell": "yc",
            "url": "yancheng",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "33.379861877121",
            "lng": "120.14887181794",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:51",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:51",
            "deleted": "0"
        },
        {
            "id": "123",
            "type": "3",
            "content": "扬州",
            "spell": "yangzhou",
            "shortspell": "yz",
            "url": "yangzhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "32.408505254568",
            "lng": "119.42777755117",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:52",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:52",
            "deleted": "0"
        },
        {
            "id": "124",
            "type": "3",
            "content": "镇江",
            "spell": "zhenjiang",
            "shortspell": "zj",
            "url": "zhenjiang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "32.204409443599",
            "lng": "119.45583540513",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:54",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:54",
            "deleted": "0"
        },
        {
            "id": "125",
            "type": "3",
            "content": "泰州",
            "spell": "taizhou",
            "shortspell": "tz",
            "url": "taizhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "32.47605327483",
            "lng": "119.91960601619",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:55",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:55",
            "deleted": "0"
        },
        {
            "id": "126",
            "type": "3",
            "content": "宿迁",
            "spell": "suqian",
            "shortspell": "sq",
            "url": "suqian",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "33.952049733709",
            "lng": "118.29689337855",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:57",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:57",
            "deleted": "0"
        }
    ],
    "21": [
        {
            "id": "127",
            "type": "3",
            "content": "杭州",
            "spell": "hangzhou",
            "shortspell": "hz",
            "url": "hangzhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "30.259244461536",
            "lng": "120.21937541572",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:58",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:58",
            "deleted": "0"
        },
        {
            "id": "128",
            "type": "3",
            "content": "宁波",
            "spell": "ningbo",
            "shortspell": "nb",
            "url": "ningbo",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "29.885258965918",
            "lng": "121.57900597259",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:28:59",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:28:59",
            "deleted": "0"
        },
        {
            "id": "129",
            "type": "3",
            "content": "温州",
            "spell": "wenzhou",
            "shortspell": "wz",
            "url": "wenzhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "28.002837594041",
            "lng": "120.69063473371",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:01",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:01",
            "deleted": "0"
        },
        {
            "id": "130",
            "type": "3",
            "content": "嘉兴",
            "spell": "jiaxing",
            "shortspell": "jx",
            "url": "jiaxing",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "30.773992239582",
            "lng": "120.76042769896",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:02",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:02",
            "deleted": "0"
        },
        {
            "id": "131",
            "type": "3",
            "content": "湖州",
            "spell": "huzhou",
            "shortspell": "hz",
            "url": "huzhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "30.877925155691",
            "lng": "120.13724316328",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:04",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:04",
            "deleted": "0"
        },
        {
            "id": "132",
            "type": "3",
            "content": "绍兴",
            "spell": "shaoxing",
            "shortspell": "sx",
            "url": "shaoxing",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "30.002364580528",
            "lng": "120.59246738555",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:05",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:05",
            "deleted": "0"
        },
        {
            "id": "133",
            "type": "3",
            "content": "金华",
            "spell": "jinhua",
            "shortspell": "jh",
            "url": "jinhua",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "29.102899105391",
            "lng": "119.65257570368",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:07",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:07",
            "deleted": "0"
        },
        {
            "id": "134",
            "type": "3",
            "content": "衢州",
            "spell": "quzhou",
            "shortspell": "qz",
            "url": "quzhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "28.956910447536",
            "lng": "118.87584165151",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:09",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:09",
            "deleted": "0"
        },
        {
            "id": "135",
            "type": "3",
            "content": "舟山",
            "spell": "zhoushan",
            "shortspell": "zs",
            "url": "zhoushan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "30.036010302554",
            "lng": "122.16987209835",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:11",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:11",
            "deleted": "0"
        },
        {
            "id": "136",
            "type": "3",
            "content": "台州",
            "spell": "taizhou",
            "shortspell": "tz",
            "url": "taizhou1",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "28.668283285674",
            "lng": "121.44061293594",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:12",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:12",
            "deleted": "0"
        },
        {
            "id": "137",
            "type": "3",
            "content": "丽水",
            "spell": "lishui",
            "shortspell": "ls",
            "url": "lishui",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "28.456299552144",
            "lng": "119.92957584319",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:14",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:14",
            "deleted": "0"
        }
    ],
    "22": [
        {
            "id": "138",
            "type": "3",
            "content": "合肥",
            "spell": "hefei",
            "shortspell": "hf",
            "url": "hefei",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "31.866942260687",
            "lng": "117.28269909168",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:16",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:16",
            "deleted": "0"
        },
        {
            "id": "139",
            "type": "3",
            "content": "芜湖",
            "spell": "wuhu",
            "shortspell": "wh",
            "url": "wuhu",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "31.366019787543",
            "lng": "118.38410842323",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:18",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:18",
            "deleted": "0"
        },
        {
            "id": "140",
            "type": "3",
            "content": "蚌埠",
            "spell": "bangbu",
            "shortspell": "bb",
            "url": "bangbu",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "32.929498906698",
            "lng": "117.35707986588",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:19",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:19",
            "deleted": "0"
        },
        {
            "id": "141",
            "type": "3",
            "content": "淮南",
            "spell": "huainan",
            "shortspell": "hn",
            "url": "huainan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "32.642811823748",
            "lng": "117.01863886329",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:21",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:21",
            "deleted": "0"
        },
        {
            "id": "142",
            "type": "3",
            "content": "马鞍山",
            "spell": "maanshan",
            "shortspell": "mas",
            "url": "maanshan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "31.68852815888",
            "lng": "118.51588184662",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:22",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:22",
            "deleted": "0"
        },
        {
            "id": "143",
            "type": "3",
            "content": "淮北",
            "spell": "huaibei",
            "shortspell": "hb",
            "url": "huaibei",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "33.960023305364",
            "lng": "116.79144742863",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:23",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:23",
            "deleted": "0"
        },
        {
            "id": "144",
            "type": "3",
            "content": "铜陵",
            "spell": "tongling",
            "shortspell": "tl",
            "url": "tongling",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "30.940929694666",
            "lng": "117.81942872881",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:25",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:25",
            "deleted": "0"
        },
        {
            "id": "145",
            "type": "3",
            "content": "安庆",
            "spell": "anqing",
            "shortspell": "aq",
            "url": "anqing",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "30.537897817381",
            "lng": "117.05873877211",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:26",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:26",
            "deleted": "0"
        },
        {
            "id": "146",
            "type": "3",
            "content": "黄山",
            "spell": "huangshan",
            "shortspell": "hs",
            "url": "huangshan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "30.27774589512",
            "lng": "118.07754612726",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:28",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:28",
            "deleted": "0"
        },
        {
            "id": "147",
            "type": "3",
            "content": "滁州",
            "spell": "chuzhou",
            "shortspell": "cz",
            "url": "chuzhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "32.317350595384",
            "lng": "118.32457035098",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:29",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:29",
            "deleted": "0"
        },
        {
            "id": "148",
            "type": "3",
            "content": "阜阳",
            "spell": "fuyang",
            "shortspell": "fy",
            "url": "fuyang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "32.90121133057",
            "lng": "115.82093225905",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:31",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:31",
            "deleted": "0"
        },
        {
            "id": "149",
            "type": "3",
            "content": "宿州",
            "spell": "suzhou",
            "shortspell": "sz",
            "url": "suzhou1",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "33.636772385781",
            "lng": "116.98869241183",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:32",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:32",
            "deleted": "0"
        },
        {
            "id": "150",
            "type": "3",
            "content": "巢湖",
            "spell": "chaohu",
            "shortspell": "ch",
            "url": "chaohu",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "31.608732547546",
            "lng": "117.88049041703",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:33",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:33",
            "deleted": "0"
        },
        {
            "id": "151",
            "type": "3",
            "content": "六安",
            "spell": "liuan",
            "shortspell": "la",
            "url": "liuan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "31.755558355198",
            "lng": "116.50525268298",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:35",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:35",
            "deleted": "0"
        },
        {
            "id": "152",
            "type": "3",
            "content": "亳州",
            "spell": "bozhou",
            "shortspell": "bz",
            "url": "bozhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "33.871210565302",
            "lng": "115.78792824512",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:36",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:36",
            "deleted": "0"
        },
        {
            "id": "153",
            "type": "3",
            "content": "池州",
            "spell": "chizhou",
            "shortspell": "cz",
            "url": "chizhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "30.660019248161",
            "lng": "117.49447677159",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:38",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:38",
            "deleted": "0"
        },
        {
            "id": "154",
            "type": "3",
            "content": "宣城",
            "spell": "xuancheng",
            "shortspell": "xc",
            "url": "xuancheng",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "30.951642354296",
            "lng": "118.75209631098",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:41",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:41",
            "deleted": "0"
        }
    ],
    "23": [
        {
            "id": "155",
            "type": "3",
            "content": "福州",
            "spell": "fuzhou",
            "shortspell": "fz",
            "url": "fuzhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "26.047125496573",
            "lng": "119.33022110713",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:42",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:42",
            "deleted": "0"
        },
        {
            "id": "156",
            "type": "3",
            "content": "厦门",
            "spell": "xiamen",
            "shortspell": "xm",
            "url": "xiamen",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "24.489230612469",
            "lng": "118.10388604566",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:43",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:43",
            "deleted": "0"
        },
        {
            "id": "157",
            "type": "3",
            "content": "莆田",
            "spell": "putian",
            "shortspell": "pt",
            "url": "putian",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "25.448450136734",
            "lng": "119.07773096396",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:45",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:45",
            "deleted": "0"
        },
        {
            "id": "158",
            "type": "3",
            "content": "三明",
            "spell": "sanming",
            "shortspell": "sm",
            "url": "sanming",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "26.270835279362",
            "lng": "117.64219393404",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:46",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:46",
            "deleted": "0"
        },
        {
            "id": "159",
            "type": "3",
            "content": "泉州",
            "spell": "quanzhou",
            "shortspell": "qz",
            "url": "quanzhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "24.901652383991",
            "lng": "118.60036234323",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:48",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:48",
            "deleted": "0"
        },
        {
            "id": "160",
            "type": "3",
            "content": "漳州",
            "spell": "zhangzhou",
            "shortspell": "zz",
            "url": "zhangzhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "24.517064779808",
            "lng": "117.67620467895",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:49",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:49",
            "deleted": "0"
        },
        {
            "id": "161",
            "type": "3",
            "content": "南平",
            "spell": "nanping",
            "shortspell": "np",
            "url": "nanping",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "26.643626474198",
            "lng": "118.18188294866",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:50",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:50",
            "deleted": "0"
        },
        {
            "id": "162",
            "type": "3",
            "content": "龙岩",
            "spell": "longyan",
            "shortspell": "ly",
            "url": "longyan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "25.078685433515",
            "lng": "117.01799673877",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:52",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:52",
            "deleted": "0"
        },
        {
            "id": "163",
            "type": "3",
            "content": "宁德",
            "spell": "ningde",
            "shortspell": "nd",
            "url": "ningde",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "26.656527419159",
            "lng": "119.54208214972",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:53",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:53",
            "deleted": "0"
        }
    ],
    "24": [
        {
            "id": "164",
            "type": "3",
            "content": "南昌",
            "spell": "nanchang",
            "shortspell": "nc",
            "url": "nanchang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "28.689578000141",
            "lng": "115.89352754584",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:55",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:55",
            "deleted": "0"
        },
        {
            "id": "165",
            "type": "3",
            "content": "景德镇",
            "spell": "jingdezhen",
            "shortspell": "jdz",
            "url": "jingdezhen",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "29.303562768448",
            "lng": "117.18652262527",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:56",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:56",
            "deleted": "0"
        },
        {
            "id": "166",
            "type": "3",
            "content": "萍乡",
            "spell": "pingxiang",
            "shortspell": "px",
            "url": "pingxiang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "27.639544222952",
            "lng": "113.85991703301",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:57",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:57",
            "deleted": "0"
        },
        {
            "id": "167",
            "type": "3",
            "content": "九江",
            "spell": "jiujiang",
            "shortspell": "jj",
            "url": "jiujiang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "29.719639526122",
            "lng": "115.99984802155",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:29:59",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:29:59",
            "deleted": "0"
        },
        {
            "id": "168",
            "type": "3",
            "content": "新余",
            "spell": "xinyu",
            "shortspell": "xy",
            "url": "xinyu",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "27.822321558629",
            "lng": "114.94711741679",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:00",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:00",
            "deleted": "0"
        },
        {
            "id": "169",
            "type": "3",
            "content": "鹰潭",
            "spell": "yingtan",
            "shortspell": "yt",
            "url": "yingtan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "28.241309597182",
            "lng": "117.03545018601",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:02",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:02",
            "deleted": "0"
        },
        {
            "id": "170",
            "type": "3",
            "content": "赣州",
            "spell": "ganzhou",
            "shortspell": "gz",
            "url": "ganzhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "25.845295536347",
            "lng": "114.93590907928",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:03",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:03",
            "deleted": "0"
        },
        {
            "id": "171",
            "type": "3",
            "content": "吉安",
            "spell": "jian",
            "shortspell": "ja",
            "url": "jian",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "27.113847650157",
            "lng": "114.99203871092",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:04",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:04",
            "deleted": "0"
        },
        {
            "id": "172",
            "type": "3",
            "content": "宜春",
            "spell": "yichun",
            "shortspell": "yc",
            "url": "yichun1",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "27.811129895843",
            "lng": "114.40003867156",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:06",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:06",
            "deleted": "0"
        },
        {
            "id": "173",
            "type": "3",
            "content": "抚州",
            "spell": "fuzhou",
            "shortspell": "fz",
            "url": "fuzhou1",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "27.95454517027",
            "lng": "116.36091886693",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:07",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:07",
            "deleted": "0"
        },
        {
            "id": "174",
            "type": "3",
            "content": "上饶",
            "spell": "shangrao",
            "shortspell": "sr",
            "url": "shangrao",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "28.457622553937",
            "lng": "117.95546387715",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:08",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:08",
            "deleted": "0"
        }
    ],
    "25": [
        {
            "id": "175",
            "type": "3",
            "content": "济南",
            "spell": "jinan",
            "shortspell": "jn",
            "url": "jinan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "36.682784727161",
            "lng": "117.02496706629",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:10",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:10",
            "deleted": "0"
        },
        {
            "id": "176",
            "type": "3",
            "content": "青岛",
            "spell": "qingdao",
            "shortspell": "qd",
            "url": "qingdao",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "36.105214901274",
            "lng": "120.38442818368",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:11",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:11",
            "deleted": "0"
        },
        {
            "id": "177",
            "type": "3",
            "content": "淄博",
            "spell": "zibo",
            "shortspell": "zb",
            "url": "zibo",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "36.804684854212",
            "lng": "118.05913427787",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:13",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:13",
            "deleted": "0"
        },
        {
            "id": "178",
            "type": "3",
            "content": "枣庄",
            "spell": "zaozhuang",
            "shortspell": "zz",
            "url": "zaozhuang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "34.807883078386",
            "lng": "117.2793053833",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:14",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:14",
            "deleted": "0"
        },
        {
            "id": "179",
            "type": "3",
            "content": "东营",
            "spell": "dongying",
            "shortspell": "dy",
            "url": "dongying",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "37.408666288041",
            "lng": "118.61264305188",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:16",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:16",
            "deleted": "0"
        },
        {
            "id": "180",
            "type": "3",
            "content": "烟台",
            "spell": "yantai",
            "shortspell": "yt",
            "url": "yantai",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "37.53656156286",
            "lng": "121.30955503009",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:17",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:17",
            "deleted": "0"
        },
        {
            "id": "181",
            "type": "3",
            "content": "潍坊",
            "spell": "weifang",
            "shortspell": "wf",
            "url": "weifang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "36.716114873051",
            "lng": "119.14263382297",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:19",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:19",
            "deleted": "0"
        },
        {
            "id": "182",
            "type": "3",
            "content": "济宁",
            "spell": "jining",
            "shortspell": "jn",
            "url": "jining",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "35.402121664331",
            "lng": "116.60079762482",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:20",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:20",
            "deleted": "0"
        },
        {
            "id": "183",
            "type": "3",
            "content": "泰安",
            "spell": "taian",
            "shortspell": "ta",
            "url": "taian",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "36.188077758948",
            "lng": "117.08941491714",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:21",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:21",
            "deleted": "0"
        },
        {
            "id": "184",
            "type": "3",
            "content": "威海",
            "spell": "weihai",
            "shortspell": "wh",
            "url": "weihai",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "37.528787081251",
            "lng": "122.09395836581",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:23",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:23",
            "deleted": "0"
        },
        {
            "id": "185",
            "type": "3",
            "content": "日照",
            "spell": "rizhao",
            "shortspell": "rz",
            "url": "rizhao",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "35.420225193144",
            "lng": "119.50717994299",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:24",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:24",
            "deleted": "0"
        },
        {
            "id": "186",
            "type": "3",
            "content": "莱芜",
            "spell": "laiwu",
            "shortspell": "lw",
            "url": "laiwu",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "36.233654133647",
            "lng": "117.68466691247",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:26",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:26",
            "deleted": "0"
        },
        {
            "id": "187",
            "type": "3",
            "content": "临沂",
            "spell": "linyi",
            "shortspell": "ly",
            "url": "linyi",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "35.072409074391",
            "lng": "118.34076823661",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:27",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:27",
            "deleted": "0"
        },
        {
            "id": "188",
            "type": "3",
            "content": "德州",
            "spell": "dezhou",
            "shortspell": "dz",
            "url": "dezhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "37.460825926305",
            "lng": "116.32816136356",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:29",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:29",
            "deleted": "0"
        },
        {
            "id": "189",
            "type": "3",
            "content": "聊城",
            "spell": "liaocheng",
            "shortspell": "lc",
            "url": "liaocheng",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "36.455828514728",
            "lng": "115.98686913929",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:30",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:30",
            "deleted": "0"
        },
        {
            "id": "190",
            "type": "3",
            "content": "滨州",
            "spell": "binzhou",
            "shortspell": "bz",
            "url": "binzhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "37.405313941826",
            "lng": "117.96829241453",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:31",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:31",
            "deleted": "0"
        },
        {
            "id": "191",
            "type": "3",
            "content": "菏泽",
            "spell": "heze",
            "shortspell": "hz",
            "url": "heze",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "26.071112134561",
            "lng": "119.29387934926",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:33",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:33",
            "deleted": "0"
        }
    ],
    "26": [
        {
            "id": "192",
            "type": "3",
            "content": "郑州",
            "spell": "zhengzhou",
            "shortspell": "zz",
            "url": "zhengzhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "34.75661006414",
            "lng": "113.64964384986",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:34",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:34",
            "deleted": "0"
        },
        {
            "id": "193",
            "type": "3",
            "content": "开封",
            "spell": "kaifeng",
            "shortspell": "kf",
            "url": "kaifeng",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "34.801854175837",
            "lng": "114.35164211776",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:35",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:35",
            "deleted": "0"
        },
        {
            "id": "194",
            "type": "3",
            "content": "洛阳",
            "spell": "luoyang",
            "shortspell": "ly",
            "url": "luoyang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "34.657367817651",
            "lng": "112.44752476895",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:37",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:37",
            "deleted": "0"
        },
        {
            "id": "195",
            "type": "3",
            "content": "平顶山",
            "spell": "pingdingshan",
            "shortspell": "pds",
            "url": "pingdingshan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "33.745301456524",
            "lng": "113.30084897798",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:41",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:41",
            "deleted": "0"
        },
        {
            "id": "196",
            "type": "3",
            "content": "安阳",
            "spell": "anyang",
            "shortspell": "ay",
            "url": "anyang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "36.110266722181",
            "lng": "114.35180650767",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:42",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:42",
            "deleted": "0"
        },
        {
            "id": "197",
            "type": "3",
            "content": "鹤壁",
            "spell": "hebi",
            "shortspell": "hb",
            "url": "hebi",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "35.755425874224",
            "lng": "114.29776983802",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:44",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:44",
            "deleted": "0"
        },
        {
            "id": "198",
            "type": "3",
            "content": "新乡",
            "spell": "xinxiang",
            "shortspell": "xx",
            "url": "xinxiang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "35.307257557661",
            "lng": "113.91269016082",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:46",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:46",
            "deleted": "0"
        },
        {
            "id": "199",
            "type": "3",
            "content": "焦作",
            "spell": "jiaozuo",
            "shortspell": "jz",
            "url": "jiaozuo",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "35.234607554986",
            "lng": "113.21183588499",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:47",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:47",
            "deleted": "0"
        },
        {
            "id": "200",
            "type": "3",
            "content": "濮阳",
            "spell": "puyang",
            "shortspell": "py",
            "url": "puyang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "35.753297888208",
            "lng": "115.02662744067",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:50",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:50",
            "deleted": "0"
        },
        {
            "id": "201",
            "type": "3",
            "content": "许昌",
            "spell": "xuchang",
            "shortspell": "xc",
            "url": "xuchang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "34.026739588655",
            "lng": "113.83531245979",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:51",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:51",
            "deleted": "0"
        },
        {
            "id": "202",
            "type": "3",
            "content": "漯河",
            "spell": "luohe",
            "shortspell": "lh",
            "url": "luohe",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "33.576278688483",
            "lng": "114.04606140023",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:52",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:52",
            "deleted": "0"
        },
        {
            "id": "203",
            "type": "3",
            "content": "三门峡",
            "spell": "sanmenxia",
            "shortspell": "smx",
            "url": "sanmenxia",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "34.78331994105",
            "lng": "111.18126209327",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:54",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:54",
            "deleted": "0"
        },
        {
            "id": "204",
            "type": "3",
            "content": "南阳",
            "spell": "nanyang",
            "shortspell": "ny",
            "url": "nanyang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "33.011419569116",
            "lng": "112.54284190051",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:55",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:55",
            "deleted": "0"
        },
        {
            "id": "205",
            "type": "3",
            "content": "商丘",
            "spell": "shangqiu",
            "shortspell": "sq",
            "url": "shangqiu",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "34.438588640246",
            "lng": "115.64188568785",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:57",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:57",
            "deleted": "0"
        },
        {
            "id": "206",
            "type": "3",
            "content": "信阳",
            "spell": "xinyang",
            "shortspell": "xy",
            "url": "xinyang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "32.128582307512",
            "lng": "114.08549099347",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:58",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:58",
            "deleted": "0"
        },
        {
            "id": "207",
            "type": "3",
            "content": "周口",
            "spell": "zhoukou",
            "shortspell": "zk",
            "url": "zhoukou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "33.623740818141",
            "lng": "114.6541019423",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:30:59",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:30:59",
            "deleted": "0"
        },
        {
            "id": "208",
            "type": "3",
            "content": "驻马店",
            "spell": "zhumadian",
            "shortspell": "zmd",
            "url": "zhumadian",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "32.983158154093",
            "lng": "114.04915354746",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:01",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:01",
            "deleted": "0"
        },
        {
            "id": "209",
            "type": "3",
            "content": "济源",
            "spell": "jiyuan",
            "shortspell": "jy",
            "url": "jiyuan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "35.105364562479",
            "lng": "112.40526796973",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:02",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:02",
            "deleted": "0"
        }
    ],
    "27": [
        {
            "id": "210",
            "type": "3",
            "content": "武汉",
            "spell": "wuhan",
            "shortspell": "wh",
            "url": "wuhan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "30.581084126921",
            "lng": "114.31620010268",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:03",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:03",
            "deleted": "0"
        },
        {
            "id": "211",
            "type": "3",
            "content": "黄石",
            "spell": "huangshi",
            "shortspell": "hs",
            "url": "huangshi",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "30.216127127714",
            "lng": "115.05068316392",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:05",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:05",
            "deleted": "0"
        },
        {
            "id": "212",
            "type": "3",
            "content": "十堰",
            "spell": "shiyan",
            "shortspell": "sy",
            "url": "shiyan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "32.636994339468",
            "lng": "110.80122891676",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:06",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:06",
            "deleted": "0"
        },
        {
            "id": "213",
            "type": "3",
            "content": "宜昌",
            "spell": "yichang",
            "shortspell": "yc",
            "url": "yichang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "30.732757818026",
            "lng": "111.31098109196",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:07",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:07",
            "deleted": "0"
        },
        {
            "id": "214",
            "type": "3",
            "content": "襄阳",
            "spell": "xiangyang",
            "shortspell": "xy",
            "url": "xiangyang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "32.229168591538",
            "lng": "112.25009284837",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:09",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:09",
            "deleted": "0"
        },
        {
            "id": "215",
            "type": "3",
            "content": "鄂州",
            "spell": "ezhou",
            "shortspell": "ez",
            "url": "ezhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "30.384439322752",
            "lng": "114.89559404136",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:10",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:10",
            "deleted": "0"
        },
        {
            "id": "216",
            "type": "3",
            "content": "荆门",
            "spell": "jingmen",
            "shortspell": "jm",
            "url": "jingmen",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "31.042611202949",
            "lng": "112.21733029897",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:12",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:12",
            "deleted": "0"
        },
        {
            "id": "217",
            "type": "3",
            "content": "孝感",
            "spell": "xiaogan",
            "shortspell": "xg",
            "url": "xiaogan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "30.927954784201",
            "lng": "113.93573439207",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:13",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:13",
            "deleted": "0"
        },
        {
            "id": "218",
            "type": "3",
            "content": "荆州",
            "spell": "jingzhou",
            "shortspell": "jz",
            "url": "jingzhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "30.396103360853",
            "lng": "112.09985718065",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:15",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:15",
            "deleted": "0"
        },
        {
            "id": "219",
            "type": "3",
            "content": "黄冈",
            "spell": "huanggang",
            "shortspell": "hg",
            "url": "huanggang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "30.446108937901",
            "lng": "114.90661804658",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:16",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:16",
            "deleted": "0"
        },
        {
            "id": "220",
            "type": "3",
            "content": "咸宁",
            "spell": "xianning",
            "shortspell": "xn",
            "url": "xianning",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "29.880656757728",
            "lng": "114.30006059206",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:17",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:17",
            "deleted": "0"
        },
        {
            "id": "221",
            "type": "3",
            "content": "随州",
            "spell": "suizhou",
            "shortspell": "sz",
            "url": "suizhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "31.717857608189",
            "lng": "113.37935836429",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:19",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:19",
            "deleted": "0"
        },
        {
            "id": "222",
            "type": "3",
            "content": "恩施",
            "spell": "enshi",
            "shortspell": "es",
            "url": "enshi",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "30.308978511296",
            "lng": "109.51743266232",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:20",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:20",
            "deleted": "0"
        }
    ],
    "28": [
        {
            "id": "223",
            "type": "3",
            "content": "长沙",
            "spell": "changsha",
            "shortspell": "cs",
            "url": "changsha",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "28.213478230853",
            "lng": "112.97935278765",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:22",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:22",
            "deleted": "0"
        },
        {
            "id": "224",
            "type": "3",
            "content": "株洲",
            "spell": "zhuzhou",
            "shortspell": "zz",
            "url": "zhuzhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "27.827432927663",
            "lng": "113.13169534107",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:23",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:23",
            "deleted": "0"
        },
        {
            "id": "225",
            "type": "3",
            "content": "湘潭",
            "spell": "xiangtan",
            "shortspell": "xt",
            "url": "xiangtan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "27.835095052979",
            "lng": "112.93555563303",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:25",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:25",
            "deleted": "0"
        },
        {
            "id": "226",
            "type": "3",
            "content": "衡阳",
            "spell": "hengyang",
            "shortspell": "hy",
            "url": "hengyang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "26.898164415358",
            "lng": "112.58381881072",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:27",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:27",
            "deleted": "0"
        },
        {
            "id": "227",
            "type": "3",
            "content": "邵阳",
            "spell": "shaoyang",
            "shortspell": "sy",
            "url": "shaoyang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "27.236811244922",
            "lng": "111.46152540355",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:28",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:28",
            "deleted": "0"
        },
        {
            "id": "228",
            "type": "3",
            "content": "岳阳",
            "spell": "yueyang",
            "shortspell": "yy",
            "url": "yueyang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "29.378007075474",
            "lng": "113.14619551912",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:30",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:30",
            "deleted": "0"
        },
        {
            "id": "229",
            "type": "3",
            "content": "常德",
            "spell": "changde",
            "shortspell": "cd",
            "url": "changde",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "29.012148855181",
            "lng": "111.65371813684",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:31",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:31",
            "deleted": "0"
        },
        {
            "id": "230",
            "type": "3",
            "content": "张家界",
            "spell": "zhangjiajie",
            "shortspell": "zjj",
            "url": "zhangjiajie",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "29.12488935322",
            "lng": "110.48162015697",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:32",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:32",
            "deleted": "0"
        },
        {
            "id": "231",
            "type": "3",
            "content": "益阳",
            "spell": "yiyang",
            "shortspell": "yy",
            "url": "yiyang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "28.588087779887",
            "lng": "112.36654664523",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:34",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:34",
            "deleted": "0"
        },
        {
            "id": "232",
            "type": "3",
            "content": "郴州",
            "spell": "chenzhou",
            "shortspell": "cz",
            "url": "chenzhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "25.782263975739",
            "lng": "113.0377044678",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:35",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:35",
            "deleted": "0"
        },
        {
            "id": "233",
            "type": "3",
            "content": "永州",
            "spell": "yongzhou",
            "shortspell": "yz",
            "url": "yongzhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "26.435971646759",
            "lng": "111.61464768616",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:36",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:36",
            "deleted": "0"
        },
        {
            "id": "234",
            "type": "3",
            "content": "怀化",
            "spell": "huaihua",
            "shortspell": "hh",
            "url": "huaihua",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "27.557482901173",
            "lng": "109.98695879585",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:38",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:38",
            "deleted": "0"
        },
        {
            "id": "235",
            "type": "3",
            "content": "娄底",
            "spell": "loudi",
            "shortspell": "ld",
            "url": "loudi",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "27.741073302349",
            "lng": "111.99639635657",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:40",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:40",
            "deleted": "0"
        },
        {
            "id": "236",
            "type": "3",
            "content": "湘西",
            "spell": "xiangxi",
            "shortspell": "xx",
            "url": "xiangxi",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "28.317950793674",
            "lng": "109.74574580039",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:41",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:41",
            "deleted": "0"
        }
    ],
    "29": [
        {
            "id": "237",
            "type": "3",
            "content": "广州",
            "spell": "guangzhou",
            "shortspell": "gz",
            "url": "guangzhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "23.120049102076",
            "lng": "113.30764967515",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:42",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:42",
            "deleted": "0"
        },
        {
            "id": "238",
            "type": "3",
            "content": "韶关",
            "spell": "shaoguan",
            "shortspell": "sg",
            "url": "shaoguan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "24.802960311892",
            "lng": "113.59446110744",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:44",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:44",
            "deleted": "0"
        },
        {
            "id": "239",
            "type": "3",
            "content": "深圳",
            "spell": "shenzhen",
            "shortspell": "sz",
            "url": "shenzhen",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "22.546053546205",
            "lng": "114.02597365732",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:45",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:45",
            "deleted": "0"
        },
        {
            "id": "240",
            "type": "3",
            "content": "珠海",
            "spell": "zhuhai",
            "shortspell": "zh",
            "url": "zhuhai",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "22.256914646126",
            "lng": "113.56244702619",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:47",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:47",
            "deleted": "0"
        },
        {
            "id": "241",
            "type": "3",
            "content": "汕头",
            "spell": "shantou",
            "shortspell": "st",
            "url": "shantou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "23.383908453269",
            "lng": "116.72865028834",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:48",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:48",
            "deleted": "0"
        },
        {
            "id": "242",
            "type": "3",
            "content": "佛山",
            "spell": "foshan",
            "shortspell": "fs",
            "url": "foshan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "23.035094840514",
            "lng": "113.13402563539",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:49",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:49",
            "deleted": "0"
        },
        {
            "id": "243",
            "type": "3",
            "content": "江门",
            "spell": "jiangmen",
            "shortspell": "jm",
            "url": "jiangmen",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "22.575116783451",
            "lng": "113.07812534115",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:51",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:51",
            "deleted": "0"
        },
        {
            "id": "244",
            "type": "3",
            "content": "湛江",
            "spell": "zhanjiang",
            "shortspell": "zj",
            "url": "zhanjiang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "21.257463103764",
            "lng": "110.36506726285",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:53",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:53",
            "deleted": "0"
        },
        {
            "id": "245",
            "type": "3",
            "content": "茂名",
            "spell": "maoming",
            "shortspell": "mm",
            "url": "maoming",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "21.668225718822",
            "lng": "110.93124533068",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:54",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:54",
            "deleted": "0"
        },
        {
            "id": "246",
            "type": "3",
            "content": "肇庆",
            "spell": "zhaoqing",
            "shortspell": "zq",
            "url": "zhaoqing",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "23.078663282929",
            "lng": "112.47965336992",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:56",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:56",
            "deleted": "0"
        },
        {
            "id": "247",
            "type": "3",
            "content": "惠州",
            "spell": "huizhou",
            "shortspell": "hz",
            "url": "huizhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "23.113539852408",
            "lng": "114.41065807997",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:58",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:58",
            "deleted": "0"
        },
        {
            "id": "248",
            "type": "3",
            "content": "梅州",
            "spell": "meizhou",
            "shortspell": "mz",
            "url": "meizhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "24.304570606031",
            "lng": "116.12640309837",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:31:59",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:31:59",
            "deleted": "0"
        },
        {
            "id": "249",
            "type": "3",
            "content": "汕尾",
            "spell": "shanwei",
            "shortspell": "sw",
            "url": "shanwei",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "22.778730500164",
            "lng": "115.3729242894",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:01",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:01",
            "deleted": "0"
        },
        {
            "id": "250",
            "type": "3",
            "content": "河源",
            "spell": "heyuan",
            "shortspell": "hy",
            "url": "heyuan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "23.757250850469",
            "lng": "114.71372147587",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:02",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:02",
            "deleted": "0"
        },
        {
            "id": "251",
            "type": "3",
            "content": "阳江",
            "spell": "yangjiang",
            "shortspell": "yj",
            "url": "yangjiang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "21.871517304519",
            "lng": "111.97700975587",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:03",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:03",
            "deleted": "0"
        },
        {
            "id": "252",
            "type": "3",
            "content": "清远",
            "spell": "qingyuan",
            "shortspell": "qy",
            "url": "qingyuan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "23.698468550422",
            "lng": "113.04077334891",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:05",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:05",
            "deleted": "0"
        },
        {
            "id": "253",
            "type": "3",
            "content": "东莞",
            "spell": "dongguan",
            "shortspell": "dg",
            "url": "gongguan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "23.043023815368",
            "lng": "113.76343399076",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:06",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:06",
            "deleted": "0"
        },
        {
            "id": "254",
            "type": "3",
            "content": "中山",
            "spell": "zhongshan",
            "shortspell": "zs",
            "url": "zhongshan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "38.900436431992",
            "lng": "121.67796628923",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:07",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:07",
            "deleted": "0"
        },
        {
            "id": "255",
            "type": "3",
            "content": "潮州",
            "spell": "chaozhou",
            "shortspell": "cz",
            "url": "chaozhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "23.661811676517",
            "lng": "116.63007599086",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:09",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:09",
            "deleted": "0"
        },
        {
            "id": "256",
            "type": "3",
            "content": "揭阳",
            "spell": "jieyang",
            "shortspell": "jy",
            "url": "jieyang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "23.547999466926",
            "lng": "116.37950085538",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:11",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:11",
            "deleted": "0"
        },
        {
            "id": "257",
            "type": "3",
            "content": "云浮",
            "spell": "yunfu",
            "shortspell": "yf",
            "url": "yunfu",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "22.937975685537",
            "lng": "112.05094595865",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:13",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:13",
            "deleted": "0"
        }
    ],
    "30": [
        {
            "id": "258",
            "type": "3",
            "content": "南宁",
            "spell": "nanning",
            "shortspell": "nn",
            "url": "nanning",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "22.806492935603",
            "lng": "108.29723355587",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:14",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:14",
            "deleted": "0"
        },
        {
            "id": "259",
            "type": "3",
            "content": "柳州",
            "spell": "liuzhou",
            "shortspell": "lz",
            "url": "liuzhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "24.329053352467",
            "lng": "109.42240181015",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:15",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:15",
            "deleted": "0"
        },
        {
            "id": "260",
            "type": "3",
            "content": "桂林",
            "spell": "guilin",
            "shortspell": "gl",
            "url": "guilin",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "25.262901245955",
            "lng": "110.26092014748",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:17",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:17",
            "deleted": "0"
        },
        {
            "id": "261",
            "type": "3",
            "content": "梧州",
            "spell": "wuzhou",
            "shortspell": "wz",
            "url": "wuzhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "23.485394636734",
            "lng": "111.30547195007",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:18",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:18",
            "deleted": "0"
        },
        {
            "id": "262",
            "type": "3",
            "content": "北海",
            "spell": "beihai",
            "shortspell": "bh",
            "url": "beihai",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "21.47271823501",
            "lng": "109.12262791919",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:20",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:20",
            "deleted": "0"
        },
        {
            "id": "263",
            "type": "3",
            "content": "防城港",
            "spell": "fangchenggang",
            "shortspell": "fcg",
            "url": "fangchenggang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "21.617398470472",
            "lng": "108.35179115286",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:21",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:21",
            "deleted": "0"
        },
        {
            "id": "264",
            "type": "3",
            "content": "钦州",
            "spell": "qinzhou",
            "shortspell": "qz",
            "url": "qinzhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "21.973350465313",
            "lng": "108.63879805642",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:22",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:22",
            "deleted": "0"
        },
        {
            "id": "265",
            "type": "3",
            "content": "贵港",
            "spell": "guigang",
            "shortspell": "gg",
            "url": "guigang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "23.103373164409",
            "lng": "109.61370755658",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:24",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:24",
            "deleted": "0"
        },
        {
            "id": "266",
            "type": "3",
            "content": "玉林",
            "spell": "yulin",
            "shortspell": "yl",
            "url": "yulin",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "22.643973608377",
            "lng": "110.15167631614",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:25",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:25",
            "deleted": "0"
        },
        {
            "id": "267",
            "type": "3",
            "content": "百色",
            "spell": "baise",
            "shortspell": "bs",
            "url": "baise",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "23.90151236791",
            "lng": "106.63182140365",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:27",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:27",
            "deleted": "0"
        },
        {
            "id": "268",
            "type": "3",
            "content": "贺州",
            "spell": "hezhou",
            "shortspell": "hz",
            "url": "hezhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "24.411053547113",
            "lng": "111.55259417884",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:29",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:29",
            "deleted": "0"
        },
        {
            "id": "269",
            "type": "3",
            "content": "河池",
            "spell": "hechi",
            "shortspell": "hc",
            "url": "hechi",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "24.699520782873",
            "lng": "108.06994770937",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:30",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:30",
            "deleted": "0"
        },
        {
            "id": "270",
            "type": "3",
            "content": "来宾",
            "spell": "laibin",
            "shortspell": "lb",
            "url": "laibin",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "23.741165926515",
            "lng": "109.23181650474",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:32",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:32",
            "deleted": "0"
        },
        {
            "id": "271",
            "type": "3",
            "content": "崇左",
            "spell": "chongzuo",
            "shortspell": "cz",
            "url": "chongzuo",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "22.415455296546",
            "lng": "107.35732203837",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:33",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:33",
            "deleted": "0"
        }
    ],
    "31": [
        {
            "id": "272",
            "type": "3",
            "content": "海口",
            "spell": "haikou",
            "shortspell": "hk",
            "url": "haikou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "20.022071276952",
            "lng": "110.33080184834",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:35",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:35",
            "deleted": "0"
        },
        {
            "id": "273",
            "type": "3",
            "content": "三亚",
            "spell": "sanya",
            "shortspell": "sy",
            "url": "sanya",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "18.257775914897",
            "lng": "109.52277128136",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:36",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:36",
            "deleted": "0"
        },
        {
            "id": "274",
            "type": "3",
            "content": "三沙",
            "spell": "sansha",
            "shortspell": "ss",
            "url": "sansha",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "0",
            "lng": "0",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:38",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:38",
            "deleted": "0"
        }
    ],
    "32": [
        {
            "id": "277",
            "type": "3",
            "content": "攀枝花",
            "spell": "panzhihua",
            "shortspell": "pzh",
            "url": "panzhihua",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "26.587571257109",
            "lng": "101.72242315249",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:42",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:42",
            "deleted": "0"
        },
        {
            "id": "278",
            "type": "3",
            "content": "泸州",
            "spell": "luzhou",
            "shortspell": "lz",
            "url": "luzhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "28.89592980386",
            "lng": "105.44397028921",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:44",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:44",
            "deleted": "0"
        },
        {
            "id": "279",
            "type": "3",
            "content": "德阳",
            "spell": "deyang",
            "shortspell": "dy",
            "url": "deyang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "31.131139652701",
            "lng": "104.40239781824",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:45",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:45",
            "deleted": "0"
        },
        {
            "id": "280",
            "type": "3",
            "content": "绵阳",
            "spell": "mianyang",
            "shortspell": "my",
            "url": "mianyang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "31.504701258061",
            "lng": "104.70551897529",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:47",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:47",
            "deleted": "0"
        },
        {
            "id": "281",
            "type": "3",
            "content": "广元",
            "spell": "guangyuan",
            "shortspell": "gy",
            "url": "guangyuan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "32.441040158428",
            "lng": "105.81968694",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:49",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:49",
            "deleted": "0"
        },
        {
            "id": "282",
            "type": "3",
            "content": "遂宁",
            "spell": "suining",
            "shortspell": "sn",
            "url": "suining",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "30.55749135038",
            "lng": "105.56488779226",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:51",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:51",
            "deleted": "0"
        },
        {
            "id": "283",
            "type": "3",
            "content": "内江",
            "spell": "neijiang",
            "shortspell": "nj",
            "url": "neijiang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "29.599461534775",
            "lng": "105.07305599171",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:53",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:53",
            "deleted": "0"
        },
        {
            "id": "284",
            "type": "3",
            "content": "乐山",
            "spell": "leshan",
            "shortspell": "ls",
            "url": "leshan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "29.600957611095",
            "lng": "103.76082423877",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:55",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:55",
            "deleted": "0"
        },
        {
            "id": "285",
            "type": "3",
            "content": "南充",
            "spell": "nanchong",
            "shortspell": "nc",
            "url": "nanchong",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "30.800965168237",
            "lng": "106.10555398379",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:56",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:56",
            "deleted": "0"
        },
        {
            "id": "286",
            "type": "3",
            "content": "眉山",
            "spell": "meishan",
            "shortspell": "ms",
            "url": "meishan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "30.061115079945",
            "lng": "103.84142956287",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:57",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:57",
            "deleted": "0"
        },
        {
            "id": "287",
            "type": "3",
            "content": "宜宾",
            "spell": "yibin",
            "shortspell": "yb",
            "url": "yibin",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "28.769674796266",
            "lng": "104.63301906153",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:59",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:32:59",
            "deleted": "0"
        },
        {
            "id": "288",
            "type": "3",
            "content": "广安",
            "spell": "guangan",
            "shortspell": "ga",
            "url": "guangan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "30.599249987199",
            "lng": "106.75891196362",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:00",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:00",
            "deleted": "0"
        },
        {
            "id": "289",
            "type": "3",
            "content": "达州",
            "spell": "dazhou",
            "shortspell": "dz",
            "url": "dazhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "31.214198858945",
            "lng": "107.49497344659",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:01",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:01",
            "deleted": "0"
        },
        {
            "id": "290",
            "type": "3",
            "content": "雅安",
            "spell": "yaan",
            "shortspell": "ya",
            "url": "yaan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "29.999716337066",
            "lng": "103.00935646635",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:03",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:03",
            "deleted": "0"
        },
        {
            "id": "291",
            "type": "3",
            "content": "巴中",
            "spell": "bazhong",
            "shortspell": "bz",
            "url": "bazhong",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "31.86918915916",
            "lng": "106.75791584175",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:05",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:05",
            "deleted": "0"
        },
        {
            "id": "292",
            "type": "3",
            "content": "资阳",
            "spell": "ziyang",
            "shortspell": "zy",
            "url": "ziyang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "28.694069428897",
            "lng": "112.34312135279",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:06",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:06",
            "deleted": "0"
        },
        {
            "id": "293",
            "type": "3",
            "content": "阿坝",
            "spell": "aba",
            "shortspell": "ab",
            "url": "aba",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "31.905762858339",
            "lng": "102.22856468921",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:07",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:07",
            "deleted": "0"
        },
        {
            "id": "294",
            "type": "3",
            "content": "甘孜",
            "spell": "ganzi",
            "shortspell": "gz",
            "url": "ganzi",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "30.055144114356",
            "lng": "101.96923206306",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:09",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:09",
            "deleted": "0"
        },
        {
            "id": "295",
            "type": "3",
            "content": "凉山",
            "spell": "liangshan",
            "shortspell": "ls",
            "url": "liangshan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "27.892392903666",
            "lng": "102.2595908032",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:10",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:10",
            "deleted": "0"
        },
        {
            "id": "275",
            "type": "3",
            "content": "成都",
            "spell": "chengdu",
            "shortspell": "cd",
            "url": "chengdu11",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "30.67994284542",
            "lng": "104.0679234633",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:39",
            "updateuser": "szyl_admin",
            "updatetime": "2018-01-03 14:40:10",
            "deleted": "0"
        },
        {
            "id": "276",
            "type": "3",
            "content": "自贡",
            "spell": "zigong",
            "shortspell": "zg",
            "url": "zigong11",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "29.359156889476",
            "lng": "104.77607133936",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:32:41",
            "updateuser": "szyl_admin",
            "updatetime": "2018-01-03 14:42:23",
            "deleted": "0"
        }
    ],
    "33": [
        {
            "id": "296",
            "type": "3",
            "content": "贵阳",
            "spell": "guiyang",
            "shortspell": "gy",
            "url": "guiyang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "26.629906741441",
            "lng": "106.70917709618",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:12",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:12",
            "deleted": "0"
        },
        {
            "id": "297",
            "type": "3",
            "content": "六盘水",
            "spell": "liupanshui",
            "shortspell": "lps",
            "url": "liupanshui",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "26.591866060319",
            "lng": "104.85208676007",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:13",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:13",
            "deleted": "0"
        },
        {
            "id": "298",
            "type": "3",
            "content": "遵义",
            "spell": "zunyi",
            "shortspell": "zy",
            "url": "zunyi",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "27.699961377076",
            "lng": "106.93126031648",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:14",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:14",
            "deleted": "0"
        },
        {
            "id": "299",
            "type": "3",
            "content": "安顺",
            "spell": "anshun",
            "shortspell": "as",
            "url": "anshun",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "26.228594577737",
            "lng": "105.92826996576",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:16",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:16",
            "deleted": "0"
        },
        {
            "id": "300",
            "type": "3",
            "content": "铜仁",
            "spell": "tongren",
            "shortspell": "tr",
            "url": "tongren",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "27.674902690624",
            "lng": "109.16855802826",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:17",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:17",
            "deleted": "0"
        },
        {
            "id": "301",
            "type": "3",
            "content": "黔西",
            "spell": "qianxi",
            "shortspell": "qx",
            "url": "qianxi",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "27.086384569459",
            "lng": "106.14050275681",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:19",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:19",
            "deleted": "0"
        },
        {
            "id": "302",
            "type": "3",
            "content": "毕节",
            "spell": "bijie",
            "shortspell": "bj",
            "url": "bijie",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "27.408562131331",
            "lng": "105.33332337117",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:21",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:21",
            "deleted": "0"
        },
        {
            "id": "303",
            "type": "3",
            "content": "黔东",
            "spell": "qiandong",
            "shortspell": "qd",
            "url": "qiandong",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "0",
            "lng": "0",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:22",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:22",
            "deleted": "0"
        },
        {
            "id": "304",
            "type": "3",
            "content": "黔南",
            "spell": "qiannan",
            "shortspell": "qn",
            "url": "qiannan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "26.264535997442",
            "lng": "107.52320511006",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:24",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:24",
            "deleted": "0"
        }
    ],
    "34": [
        {
            "id": "305",
            "type": "3",
            "content": "昆明",
            "spell": "kunming",
            "shortspell": "km",
            "url": "kunming",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "25.049153100453",
            "lng": "102.71460113878",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:25",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:25",
            "deleted": "0"
        },
        {
            "id": "306",
            "type": "3",
            "content": "曲靖",
            "spell": "qujing",
            "shortspell": "qj",
            "url": "qujing",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "25.520758142871",
            "lng": "103.78253888803",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:26",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:26",
            "deleted": "0"
        },
        {
            "id": "307",
            "type": "3",
            "content": "玉溪",
            "spell": "yuxi",
            "shortspell": "yx",
            "url": "yuxi",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "24.370447134438",
            "lng": "102.54506789248",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:28",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:28",
            "deleted": "0"
        },
        {
            "id": "308",
            "type": "3",
            "content": "保山",
            "spell": "baoshan",
            "shortspell": "bs",
            "url": "baoshan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "25.12048919619",
            "lng": "99.177995613278",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:29",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:29",
            "deleted": "0"
        },
        {
            "id": "309",
            "type": "3",
            "content": "昭通",
            "spell": "zhaotong",
            "shortspell": "zt",
            "url": "zhaotong",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "27.340632963635",
            "lng": "103.72502065573",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:31",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:31",
            "deleted": "0"
        },
        {
            "id": "310",
            "type": "3",
            "content": "丽江",
            "spell": "lijiang",
            "shortspell": "lj",
            "url": "lijiang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "26.875351089481",
            "lng": "100.22962839888",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:32",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:32",
            "deleted": "0"
        },
        {
            "id": "311",
            "type": "3",
            "content": "普洱",
            "spell": "puer",
            "shortspell": "pe",
            "url": "puer",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "22.788777780149",
            "lng": "100.98005773013",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:33",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:33",
            "deleted": "0"
        },
        {
            "id": "312",
            "type": "3",
            "content": "临沧",
            "spell": "lincang",
            "shortspell": "lc",
            "url": "lincang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "23.887806103773",
            "lng": "100.09261291373",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:35",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:35",
            "deleted": "0"
        },
        {
            "id": "313",
            "type": "3",
            "content": "楚雄",
            "spell": "chuxiong",
            "shortspell": "cx",
            "url": "chuxiong",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "24.880252472651",
            "lng": "101.32863799918",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:36",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:36",
            "deleted": "0"
        },
        {
            "id": "314",
            "type": "3",
            "content": "红河",
            "spell": "honghe",
            "shortspell": "hh",
            "url": "honghe",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "23.367717516499",
            "lng": "103.38406475716",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:38",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:38",
            "deleted": "0"
        },
        {
            "id": "315",
            "type": "3",
            "content": "文山",
            "spell": "wenshan",
            "shortspell": "ws",
            "url": "wenshan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "23.416009535072",
            "lng": "104.03093981246",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:39",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:39",
            "deleted": "0"
        },
        {
            "id": "316",
            "type": "3",
            "content": "西双版纳",
            "spell": "xishuangbanna",
            "shortspell": "xsbn",
            "url": "xishuangbanna",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "22.009433002236",
            "lng": "100.80303827521",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:40",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:40",
            "deleted": "0"
        },
        {
            "id": "317",
            "type": "3",
            "content": "大理",
            "spell": "dali",
            "shortspell": "dl",
            "url": "dali",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "25.693966622473",
            "lng": "100.21920895422",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:42",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:42",
            "deleted": "0"
        },
        {
            "id": "318",
            "type": "3",
            "content": "德宏",
            "spell": "dehong",
            "shortspell": "dh",
            "url": "dehong",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "24.441239663008",
            "lng": "98.589434287407",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:43",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:43",
            "deleted": "0"
        },
        {
            "id": "319",
            "type": "3",
            "content": "怒江",
            "spell": "nujiang",
            "shortspell": "nj",
            "url": "nujiang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "25.860676978165",
            "lng": "98.859932042482",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:45",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:45",
            "deleted": "0"
        },
        {
            "id": "320",
            "type": "3",
            "content": "迪庆",
            "spell": "diqing",
            "shortspell": "dq",
            "url": "diqing",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "27.831029461167",
            "lng": "99.713681598883",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:46",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:46",
            "deleted": "0"
        }
    ],
    "35": [
        {
            "id": "321",
            "type": "3",
            "content": "拉萨",
            "spell": "lasa",
            "shortspell": "ls",
            "url": "lasa",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "29.662557062057",
            "lng": "91.111890895984",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:48",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:48",
            "deleted": "0"
        },
        {
            "id": "322",
            "type": "3",
            "content": "昌都",
            "spell": "changdou",
            "shortspell": "cd",
            "url": "changdou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "31.140575631882",
            "lng": "97.185581579976",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:49",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:49",
            "deleted": "0"
        },
        {
            "id": "323",
            "type": "3",
            "content": "山南",
            "spell": "shannan",
            "shortspell": "sn",
            "url": "shannan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "29.229026931718",
            "lng": "91.750643874412",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:50",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:50",
            "deleted": "0"
        },
        {
            "id": "324",
            "type": "3",
            "content": "日喀则",
            "spell": "rikaze",
            "shortspell": "rkz",
            "url": "rikaze",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "29.268160032655",
            "lng": "88.956062773518",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:52",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:52",
            "deleted": "0"
        },
        {
            "id": "325",
            "type": "3",
            "content": "那曲",
            "spell": "naqu",
            "shortspell": "nq",
            "url": "naqu",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "31.48067983012",
            "lng": "92.067018368859",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:53",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:53",
            "deleted": "0"
        },
        {
            "id": "326",
            "type": "3",
            "content": "阿里",
            "spell": "ali",
            "shortspell": "al",
            "url": "ali",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "30.404556588325",
            "lng": "81.10766868949",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:55",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:55",
            "deleted": "0"
        },
        {
            "id": "327",
            "type": "3",
            "content": "林芝",
            "spell": "linzhi",
            "shortspell": "lz",
            "url": "linzhi",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "29.666940625813",
            "lng": "94.349985458244",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:56",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:56",
            "deleted": "0"
        }
    ],
    "36": [
        {
            "id": "328",
            "type": "3",
            "content": "西安",
            "spell": "xian",
            "shortspell": "xa",
            "url": "xian",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "42.986364946378",
            "lng": "125.15014857862",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:58",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:58",
            "deleted": "0"
        },
        {
            "id": "329",
            "type": "3",
            "content": "铜川",
            "spell": "tongchuan",
            "shortspell": "tc",
            "url": "tongchuan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "34.908367696384",
            "lng": "108.9680670134",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:33:59",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:33:59",
            "deleted": "0"
        },
        {
            "id": "330",
            "type": "3",
            "content": "宝鸡",
            "spell": "baoji",
            "shortspell": "bj",
            "url": "baoji",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "34.364080809748",
            "lng": "107.17064545238",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:00",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:00",
            "deleted": "0"
        },
        {
            "id": "331",
            "type": "3",
            "content": "咸阳",
            "spell": "xianyang",
            "shortspell": "xy",
            "url": "xianyang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "34.345372995999",
            "lng": "108.7075092782",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:02",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:02",
            "deleted": "0"
        },
        {
            "id": "332",
            "type": "3",
            "content": "渭南",
            "spell": "weinan",
            "shortspell": "wn",
            "url": "weinan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "34.502357975829",
            "lng": "109.48393269658",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:03",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:03",
            "deleted": "0"
        },
        {
            "id": "333",
            "type": "3",
            "content": "延安",
            "spell": "yanan",
            "shortspell": "ya",
            "url": "yanan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "36.60332035226",
            "lng": "109.50050975697",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:04",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:04",
            "deleted": "0"
        },
        {
            "id": "334",
            "type": "3",
            "content": "汉中",
            "spell": "hanzhong",
            "shortspell": "hz",
            "url": "hanzhong",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "33.081568978158",
            "lng": "107.04547762873",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:06",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:06",
            "deleted": "0"
        },
        {
            "id": "335",
            "type": "3",
            "content": "榆林",
            "spell": "yulin",
            "shortspell": "yl",
            "url": "yulin1",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "38.279439240071",
            "lng": "109.74592574433",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:07",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:07",
            "deleted": "0"
        },
        {
            "id": "336",
            "type": "3",
            "content": "安康",
            "spell": "ankang",
            "shortspell": "ak",
            "url": "ankang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "32.704370449994",
            "lng": "109.03804456348",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:08",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:08",
            "deleted": "0"
        },
        {
            "id": "337",
            "type": "3",
            "content": "商洛",
            "spell": "shangluo",
            "shortspell": "sl",
            "url": "shangluo",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "33.873907395085",
            "lng": "109.9342081538",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:10",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:10",
            "deleted": "0"
        }
    ],
    "37": [
        {
            "id": "338",
            "type": "3",
            "content": "兰州",
            "spell": "lanzhou",
            "shortspell": "lz",
            "url": "lanzhou",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "36.064225525043",
            "lng": "103.82330544073",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:11",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:11",
            "deleted": "0"
        },
        {
            "id": "339",
            "type": "3",
            "content": "嘉峪关",
            "spell": "jiayuguan",
            "shortspell": "jyg",
            "url": "jiayuguan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "39.802397326734",
            "lng": "98.281634585257",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:13",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:13",
            "deleted": "0"
        },
        {
            "id": "340",
            "type": "3",
            "content": "金昌",
            "spell": "jinchang",
            "shortspell": "jc",
            "url": "jinchang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "38.516071799532",
            "lng": "102.20812626259",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:14",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:14",
            "deleted": "0"
        },
        {
            "id": "341",
            "type": "3",
            "content": "白银",
            "spell": "baiyin",
            "shortspell": "by",
            "url": "baiyin",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "36.50182182871",
            "lng": "104.2056493285",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:15",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:15",
            "deleted": "0"
        },
        {
            "id": "342",
            "type": "3",
            "content": "天水",
            "spell": "tianshui",
            "shortspell": "ts",
            "url": "tianshui",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "34.584319418869",
            "lng": "105.73693162286",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:17",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:17",
            "deleted": "0"
        },
        {
            "id": "343",
            "type": "3",
            "content": "武威",
            "spell": "wuwei",
            "shortspell": "ww",
            "url": "wuwei",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "37.933172142906",
            "lng": "102.64014734337",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:19",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:19",
            "deleted": "0"
        },
        {
            "id": "344",
            "type": "3",
            "content": "张掖",
            "spell": "zhangye",
            "shortspell": "zy",
            "url": "zhangye",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "38.939320296982",
            "lng": "100.45989186892",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:20",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:20",
            "deleted": "0"
        },
        {
            "id": "345",
            "type": "3",
            "content": "平凉",
            "spell": "pingliang",
            "shortspell": "pl",
            "url": "pingliang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "35.550110190017",
            "lng": "106.68891115655",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:22",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:22",
            "deleted": "0"
        },
        {
            "id": "346",
            "type": "3",
            "content": "酒泉",
            "spell": "jiuquan",
            "shortspell": "jq",
            "url": "jiuquan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "39.741473768159",
            "lng": "98.508414506167",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:23",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:23",
            "deleted": "0"
        },
        {
            "id": "347",
            "type": "3",
            "content": "庆阳",
            "spell": "qingyang",
            "shortspell": "qy",
            "url": "qingyang",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "35.72680075453",
            "lng": "107.64422708673",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:24",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:24",
            "deleted": "0"
        },
        {
            "id": "348",
            "type": "3",
            "content": "定西",
            "spell": "dingxi",
            "shortspell": "dx",
            "url": "dingxi",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "35.586056241828",
            "lng": "104.62663760066",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:26",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:26",
            "deleted": "0"
        },
        {
            "id": "349",
            "type": "3",
            "content": "陇南",
            "spell": "longnan",
            "shortspell": "ln",
            "url": "longnan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "33.394479972938",
            "lng": "104.93457340575",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:27",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:27",
            "deleted": "0"
        },
        {
            "id": "350",
            "type": "3",
            "content": "临夏",
            "spell": "linxia",
            "shortspell": "lx",
            "url": "linxia",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "35.585834814564",
            "lng": "103.2005757611",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:29",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:29",
            "deleted": "0"
        },
        {
            "id": "351",
            "type": "3",
            "content": "甘南",
            "spell": "gannan",
            "shortspell": "gn",
            "url": "gannan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "34.992211178379",
            "lng": "102.9174424865",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:30",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:30",
            "deleted": "0"
        }
    ],
    "38": [
        {
            "id": "352",
            "type": "3",
            "content": "西宁",
            "spell": "xining",
            "shortspell": "xn",
            "url": "xining",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "36.640738611958",
            "lng": "101.7679209898",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:31",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:31",
            "deleted": "0"
        },
        {
            "id": "353",
            "type": "3",
            "content": "海东",
            "spell": "haidong",
            "shortspell": "hd",
            "url": "haidong",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "36.517610167686",
            "lng": "102.08520698745",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:33",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:33",
            "deleted": "0"
        },
        {
            "id": "354",
            "type": "3",
            "content": "海北",
            "spell": "haibei",
            "shortspell": "hb",
            "url": "haibei",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "36.960654101084",
            "lng": "100.87980217448",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:34",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:34",
            "deleted": "0"
        },
        {
            "id": "355",
            "type": "3",
            "content": "黄南",
            "spell": "huangnan",
            "shortspell": "hn",
            "url": "huangnan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "35.522851551728",
            "lng": "102.00760030834",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:36",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:36",
            "deleted": "0"
        },
        {
            "id": "356",
            "type": "3",
            "content": "海南",
            "spell": "hainan",
            "shortspell": "hn",
            "url": "hainan1",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "39.296209479392",
            "lng": "106.92539717866",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:37",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:37",
            "deleted": "0"
        },
        {
            "id": "357",
            "type": "3",
            "content": "果洛",
            "spell": "guoluo",
            "shortspell": "gl",
            "url": "guoluo",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "34.48048458461",
            "lng": "100.22372276899",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:38",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:38",
            "deleted": "0"
        },
        {
            "id": "358",
            "type": "3",
            "content": "玉树",
            "spell": "yushu",
            "shortspell": "ys",
            "url": "yushu",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "33.006239909722",
            "lng": "97.013316137414",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:40",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:40",
            "deleted": "0"
        },
        {
            "id": "359",
            "type": "3",
            "content": "海西",
            "spell": "haixi",
            "shortspell": "hx",
            "url": "haixi",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "37.37379907059",
            "lng": "97.342625415333",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:42",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:42",
            "deleted": "0"
        }
    ],
    "39": [
        {
            "id": "360",
            "type": "3",
            "content": "银川",
            "spell": "yinchuan",
            "shortspell": "yc",
            "url": "yinchuan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "38.502621011876",
            "lng": "106.20647860784",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:43",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:43",
            "deleted": "0"
        },
        {
            "id": "361",
            "type": "3",
            "content": "吴忠",
            "spell": "wuzhong",
            "shortspell": "wz",
            "url": "wuzhong",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "37.993561002936",
            "lng": "106.20825419851",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:45",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:45",
            "deleted": "0"
        },
        {
            "id": "362",
            "type": "3",
            "content": "固原",
            "spell": "guyuan",
            "shortspell": "gy",
            "url": "guyuan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "36.021523480709",
            "lng": "106.28526799598",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:46",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:46",
            "deleted": "0"
        },
        {
            "id": "363",
            "type": "3",
            "content": "中卫",
            "spell": "zhongwei",
            "shortspell": "zw",
            "url": "zhongwei",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "37.521124191595",
            "lng": "105.19675419936",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:47",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:47",
            "deleted": "0"
        }
    ],
    "40": [
        {
            "id": "364",
            "type": "3",
            "content": "乌鲁木齐",
            "spell": "wulumuqi",
            "shortspell": "wlmq",
            "url": "wulumuqi",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "43.840380347218",
            "lng": "87.564987741116",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:49",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:49",
            "deleted": "0"
        },
        {
            "id": "365",
            "type": "3",
            "content": "克拉玛依",
            "spell": "kelamayi",
            "shortspell": "klmy",
            "url": "kelamayi",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "45.203919246039",
            "lng": "84.926989634948",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:51",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:51",
            "deleted": "0"
        },
        {
            "id": "366",
            "type": "3",
            "content": "吐鲁番",
            "spell": "tulufan",
            "shortspell": "tlf",
            "url": "tulufan",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "42.678924820794",
            "lng": "89.266025488642",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:52",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:52",
            "deleted": "0"
        },
        {
            "id": "367",
            "type": "3",
            "content": "哈密",
            "spell": "hami",
            "shortspell": "hm",
            "url": "hami",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "42.344467104552",
            "lng": "93.529373012389",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:54",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:54",
            "deleted": "0"
        },
        {
            "id": "368",
            "type": "3",
            "content": "昌吉",
            "spell": "changji",
            "shortspell": "cj",
            "url": "changji",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "44.175083447891",
            "lng": "87.073618053225",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:56",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:56",
            "deleted": "0"
        },
        {
            "id": "369",
            "type": "3",
            "content": "博尔塔拉",
            "spell": "boertala",
            "shortspell": "betl",
            "url": "boertala",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "44.901267989182",
            "lng": "82.068139456014",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:57",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:57",
            "deleted": "0"
        },
        {
            "id": "370",
            "type": "3",
            "content": "巴音郭楞",
            "spell": "bayinguoleng",
            "shortspell": "bygl",
            "url": "bayinguoleng",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "42.608612242352",
            "lng": "83.654262223788",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:34:59",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:34:59",
            "deleted": "0"
        },
        {
            "id": "371",
            "type": "3",
            "content": "阿克苏",
            "spell": "akesu",
            "shortspell": "aks",
            "url": "akesu",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "40.349444301113",
            "lng": "81.156013147807",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:35:00",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:35:00",
            "deleted": "0"
        },
        {
            "id": "372",
            "type": "3",
            "content": "克孜勒苏",
            "spell": "kezilesu",
            "shortspell": "kzls",
            "url": "kezilesu",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "43.824692899181",
            "lng": "82.29458798762",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:35:01",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:35:01",
            "deleted": "0"
        },
        {
            "id": "373",
            "type": "3",
            "content": "喀什",
            "spell": "kashen",
            "shortspell": "ks",
            "url": "kashen",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "39.513110585312",
            "lng": "76.014342798943",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:35:03",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:35:03",
            "deleted": "0"
        },
        {
            "id": "374",
            "type": "3",
            "content": "和田",
            "spell": "hetian",
            "shortspell": "ht",
            "url": "hetian",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "37.153349739681",
            "lng": "79.915813731039",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:35:04",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:35:04",
            "deleted": "0"
        },
        {
            "id": "375",
            "type": "3",
            "content": "伊犁哈萨克",
            "spell": "yilihasake",
            "shortspell": "ylhsk",
            "url": "yilihasake",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "43.922248096341",
            "lng": "81.297853530366",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:35:05",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:35:05",
            "deleted": "0"
        },
        {
            "id": "376",
            "type": "3",
            "content": "塔城",
            "spell": "tacheng",
            "shortspell": "tc",
            "url": "tacheng",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "46.811367143719",
            "lng": "83.190127663082",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:35:07",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:35:07",
            "deleted": "0"
        },
        {
            "id": "377",
            "type": "3",
            "content": "阿勒泰",
            "spell": "aletai",
            "shortspell": "alt",
            "url": "aletai",
            "areafocus": "0",
            "provincefocus": "0",
            "lat": "47.890135725749",
            "lng": "87.926214360189",
            "sort": "0",
            "status": "1",
            "createuser": "dev_archive",
            "createtime": "2017-11-22 20:35:08",
            "updateuser": "dev_archive",
            "updatetime": "2017-11-22 20:35:08",
            "deleted": "0"
        }
    ],
    "41": [],
    "42": [],
    "43": [],
};